import cipher17Image1 from '../../../../assets/images/games/zdar-escape-game/ciphers/17/image1.webp';
import cipher17Image2 from '../../../../assets/images/games/zdar-escape-game/ciphers/17/image2.webp';
import cipher17Image3 from '../../../../assets/images/games/zdar-escape-game/ciphers/17/image3.webp';
import cipher17Image4 from '../../../../assets/images/games/zdar-escape-game/ciphers/17/image4.webp';
import cipher17Image5 from '../../../../assets/images/games/zdar-escape-game/ciphers/17/image5.webp';
import cipher17Image6 from '../../../../assets/images/games/zdar-escape-game/ciphers/17/image6.webp';
import cipher17Image7 from '../../../../assets/images/games/zdar-escape-game/ciphers/17/image7.webp';
import cipher17Image8 from '../../../../assets/images/games/zdar-escape-game/ciphers/17/image8.webp';
import cipher17Image9 from '../../../../assets/images/games/zdar-escape-game/ciphers/17/image9.webp';
import track17 from '../../../../assets/audio/tracks/track17.mp3';

const cipher17Images = [
    cipher17Image1,
    cipher17Image2,
    cipher17Image3,
    cipher17Image4,
    cipher17Image5,
    cipher17Image6,
    cipher17Image7,
    cipher17Image8,
    cipher17Image9,
];

export const step17fences = {
    id: 16,
    title: '7. stanoviště',
    taskText: `
        <p>
            Jéé tobě se ukázalo, kam máme jít? Tak to je super, konečně taky pomáháš. Tak jdeme. 
        </p>
    `,
    audio: track17,
    snowAudio: track17,
    cipher: {
        images: cipher17Images,
        isPathFinder: true,
    },
    catImage: 2,
    continueButtonText: 'Dále',
};
